import { useEffect } from 'react';
import { Heading, LabelText } from 'shared/components';
import { InputsContainer } from 'shared/containers';
import { CurrencyField, TextField } from 'shared/fields';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/hypotheekbespaarcheck/landing');
  }, [navigate]);

  return (
    <>
      <Heading>Oorspronkelijke situatie</Heading>
      <InputsContainer>
        <LabelText>Wat was de hoogte van je hypotheek bij de start?</LabelText>
        <CurrencyField placeholder="Bedrag" name="original_mortgage_debt" />
        <LabelText>Wat was toen de taxatiewaarde van je woning? Vul anders de koopsom in.</LabelText>
        <CurrencyField placeholder="Bedrag" name="original_house_value" />
        <LabelText>In welk jaar kocht je de woning?</LabelText>
        <TextField placeholder="Jaar" name="house_purchase_year" maxWidth="31%" inputMode='numeric'/>
      </InputsContainer>
    </>
  );
}

export default Landing;
